import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { getCategoryList, getDepartmentList, getIdea, updateIdeaStatus } from "../../services/ideas.service"
import { Ideas } from '../ideas/ideas.component'
import { CustomDropdown } from "../customDropdown/customDropdown.component"
import { CustomRadioSelection } from "../customRadioSelection/customRadioSelection.component"
import { showLoading, stopLoading } from "../../utils/alertsUtils"
import { useSelector } from "react-redux"
export const IdeaReviewForm = (props) => {
    const navigate = useNavigate()
    const empType = useSelector(state => state.user.empType)
    const { ideaId } = useParams()
    const [ideaData, setIdeaData] = useState()
    const [ideaStatus, setIdeaStatus] = useState()
    const [ideaCategory, setIdeaCategory] = useState()
    const [ideaDepartment, setIdeaDepartment] = useState()
    const [empName, setEmpName] = useState()
    const [isImplemented, setIsImplemented] = useState()
    const [isImplementedRemarks, setIsImplementedRemarks] = useState("")
    const [benefits, setBenefits] = useState("")
    const [categoryList, setCategoryList] = useState([])
    const [departmentList, setDepartmentList] = useState([])
    // const [category, setCategory] = useState()
    const options = [
        {
            ID: 1,
            VALUE: "In Review"
        },
        {
            ID: 2,
            VALUE: "Approved"
        },
        {
            ID: 3,
            VALUE: "Rejected"
        }
    ]

    const changeStatus = (value) => setIdeaStatus(value)
    const changeCategory = (value) => setIdeaCategory(value)
    const changeDepartment = (value) => setIdeaDepartment(value)

    const getIdeaData = async () => {
        const { status, data } = await getIdea(ideaId)
        if (status == 200) {
            setIsImplemented(data.IS_IMPLEMENTED)
            setIsImplementedRemarks(data.IS_IMPLEMENTED_REMARKS)
            setBenefits(data.BENEFITS)
            setIdeaData(data)
            setIdeaCategory(data.CATEGORY)
            setIdeaDepartment(data.DEPARTMENT)
            setIdeaStatus(data.STATUS)
            setEmpName(data.EMP_NAME)
            if (!data) {
                navigate('/')
            }
        }
    }
    const getCategoryListData = async () => {
        const { status, data } = await getCategoryList()
        if (status == 200) {
            setCategoryList(data)
        }
    }
    const getDepartmentListData = async () => {
        const { status, data } = await getDepartmentList()
        if (status == 200) {
            setDepartmentList(data)
        }
    }

    const sendIdeaForApproval = async () => {
        showLoading("Sending for approval")
        const { status } = await updateIdeaStatus(ideaId, "In Review", "NA", "NA")
        if (status == 200) {
            setTimeout(() => {
                stopLoading()
                window.location.reload(false)
            }, 2000)
        }
    }

    const rejectIdea = async () => {
        showLoading("Rejecting Idea")
        const { status } = await updateIdeaStatus(ideaId, "Rejected", "NA", "NA")
        if (status == 200) {
            setTimeout(() => {
                stopLoading()
                window.location.reload(false)
            }, 2000)
        }
    }

    const approveIdea = async () => {
        showLoading("Approving Idea")
        const { status } = await updateIdeaStatus(ideaId, "Approved", "NA", "NA")
        if (status == 200) {
            setTimeout(() => {
                stopLoading()
                window.location.reload(false)
            }, 2000)
        }
    }

    useEffect(() => {
        getIdeaData()
        getCategoryListData()
        getDepartmentListData()
    }, [])

    return (
        <>
            <div className="app-content content">
                <div className="content-overlay" />
                <div className="header-navbar-shadow" />
                <div className="content-wrapper">
                    <div className="content-body">
                        <div className="row">
                            <div className="col-lg-6 col-12">
                                <h2 className="mb-0">IDEA DETAILS</h2>
                                <p className="font-lato font-12">By {empName}</p>
                            </div>
                            <div className="col-lg-6 col-12 text-right">
                                <span className="badge badge-pill badge-light-primary font-lato w-100p font-11 py-5 mr-2">
                                    {ideaStatus}
                                </span>

                                {empType == 152 ? (<a onClick={sendIdeaForApproval}
                                    className={"btn btn-success font-lato text-white rounded-10 font-11 waves-effect waves-float waves-light mr-2 " + (ideaStatus == "Approved" || ideaStatus == "In Review" || ideaStatus == "Rejected" ? "disabled " : "")}
                                >
                                    <i className="fas fa-thumbs-up mr-1" />
                                    Send for approval
                                </a>)
                                    :
                                    (<a onClick={approveIdea}
                                        className={"btn btn-success font-lato text-white rounded-10 font-11 waves-effect waves-float waves-light mr-2 " + (ideaStatus == "Approved" || ideaStatus == "Rejected" ? "disabled " : "")}
                                    >
                                        <i className="fas fa-thumbs-up mr-1" />
                                        Approve
                                    </a>)}

                                <a onClick={rejectIdea}
                                    className={"btn btn-danger font-lato text-white rounded-10 font-11 waves-effect waves-float waves-light mr-2 " + (ideaStatus == "Approved" || ideaStatus == "In Review" && empType == 152 || ideaStatus == "Rejected" ? "disabled " : "")}
                                >
                                    <i className="fas fa-thumbs-down mr-1" />
                                    Reject
                                </a>
                                {/* <a onClick={updateIdea}
                                    className="btn btn-primary font-lato text-white rounded-10 font-11 waves-effect waves-float waves-light"
                                >
                                    <i className="fas fa-sync mr-1" />
                                    Update
                                </a> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-12">
                                <div className="row">

                                    {/* <div className="col-12 col-lg-12">
                                        <CustomDropdown key={1} name={"UPDATE STATUS"} currentValue={ideaStatus} options={options} isDisable={ideaData && (ideaData.STATUS == 'Approved' || ideaData.STATUS == 'Rejected' ? true : false)} setOptionValue={changeStatus} />
                                    </div> */}
                                    <div className="col-12 col-lg-12">
                                        <CustomDropdown key={2} name={"CATEGORY"} isDisable={true} currentValue={"NA"} options={[{ ID: 1, VALUE: "NA" }]} setOptionValue={changeCategory} />
                                    </div>
                                    <div className="col-12 col-lg-12">
                                        <CustomDropdown key={3} name={"RELATED DEPARTMENT"} isDisable={true} currentValue={"NA"} options={[{ ID: 1, VALUE: "NA" }]} setOptionValue={changeDepartment} />
                                    </div>

                                </div>
                                <h5>IS THIS IDEA IMPLEMENT ELSEWHERE ?</h5>
                                <div className="row">
                                    <div className="col-6 col-lg-6">
                                        <div className={isImplemented == 1 ? "checked card" : "card"}>
                                            <div className="card-body p-1">
                                                <div className="custom-control custom-radio disable">
                                                    <input
                                                        type="radio"
                                                        id="radioa"
                                                        name="radio1"
                                                        className="custom-control-input"
                                                        checked={isImplemented == 1}
                                                        readOnly

                                                    />
                                                    <label className="custom-control-label" htmlFor="radioa">
                                                        YES
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-lg-6">
                                        <div className={isImplemented == 1 ? "card" : "checked card"}>
                                            <div className="card-body p-1">
                                                <div className="custom-control custom-radio disable">
                                                    <input
                                                        type="radio"
                                                        id="radiob"
                                                        name="radio1"
                                                        className="custom-control-input"
                                                        checked={isImplemented == 0}
                                                        readOnly
                                                    />
                                                    <label className="custom-control-label" htmlFor="radiob">
                                                        NO
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {isImplemented == 1 &&
                                        <div className="col-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="form-group">
                                                        <label className="h5">
                                                            REMARKS <span className="text-danger">*</span>
                                                        </label>
                                                        <textarea
                                                            className="form-control"
                                                            rows={3}
                                                            style={{ height: 114 }}
                                                            defaultValue={
                                                                isImplementedRemarks
                                                            }
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label className="h5">
                                                        BENEFITS <span className="text-danger">*</span>
                                                    </label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={3}
                                                        defaultValue={benefits
                                                        }
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-12">
                                {ideaData && <Ideas ideaId={ideaData.IDEA_ID} Name={ideaData.EMP_NAME} Desc={ideaData.IDEA_DETAIL} CreatedAt={ideaData.createdAt} Attachments={ideaData.attachments} hearts={ideaData.hearts} likes={ideaData.likes} dislikes={ideaData.dislikes} comments={ideaData.comments} reactionId={ideaData.reactionId} reactionType={ideaData.reactionType} />}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="footer">
                                    <p className="mb-0">©2025 Protiviti Inc. All Rights Reserved.</p>
                                    <p className="mb-0">
                                        Protiviti Inc. is an Equal Opportunity Employer,
                                        M/F/Disability/Vet
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}